import PropTypes from 'prop-types'
import { compose, withState, withHandlers } from 'recompose'

import { withComponentWillUnmount } from 'hoc/withComponentWillUnmount'
import { withComponentDidUpdate } from 'hoc/withComponentDidUpdate'

const handleOnClick =
  ({ isOpen, container, onHide, excludedElement }) =>
  ({ target }) => {
    target !== excludedElement && isOpen && container && !container.contains(target) && target.isConnected && onHide()
  }

const handleAddEventListeners =
  ({ isEventsAttached, setIsEventsAttached, handleOnClick }) =>
  () => {
    if (!isEventsAttached) {
      document.addEventListener('click', handleOnClick)
      setIsEventsAttached(true)
    }
  }

const handleRemoveEventListeners =
  ({ isEventsAttached, setIsEventsAttached, handleOnClick }) =>
  () => {
    if (isEventsAttached) {
      document.removeEventListener('click', handleOnClick)
      setIsEventsAttached(false)
    }
  }

const handleComponentDidUpdate = ({ isOpen, handleAddEventListeners, handleRemoveEventListeners }) => {
  isOpen ? handleAddEventListeners() : handleRemoveEventListeners()
}

const handleComponentWillUnmount = ({ handleRemoveEventListeners }) => handleRemoveEventListeners()

const enhance = compose(
  withState('isEventsAttached', 'setIsEventsAttached', false),
  withHandlers({ handleOnClick }),
  withHandlers({
    handleAddEventListeners,
    handleRemoveEventListeners,
  }),
  withComponentDidUpdate(handleComponentDidUpdate),
  withComponentWillUnmount(handleComponentWillUnmount),
)

export const Overlay = enhance(({ isOpen, children }) => isOpen && children)

Overlay.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  container: PropTypes.object,
}
